import React from "react";
import { Button, Tooltip } from "../design";
import { copyText } from "../lib/clipboard";

export function AgentPrompt({
  prompt,
  onCopied,
  variant = "ghost",
}: {
  prompt: string;
  onCopied?: () => void;
  variant?: "ghost" | "secondary";
}) {
  const [flash, setFlash] = React.useState<string | null>(null);
  const timer = React.useRef<ReturnType<typeof setTimeout>>();

  React.useEffect(() => {
    setFlash(null);
    return () => clearTimeout(timer.current);
  }, [prompt]);

  const copy = async () => {
    const ok = await copyText(prompt);
    setFlash(ok ? "Prompt copied" : "Copy failed. Try again.");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setFlash(null), 1500);
    if (ok) onCopied?.();
  };

  return (
    <Tooltip
      text={flash ?? "Copy a prompt to paste into your coding agent"}
      show={!!flash}
    >
      <Button
        size="sm"
        variant={variant}
        icon={flash === "Prompt copied" ? "check" : "copy"}
        onClick={() => void copy()}
      >
        <span aria-live="polite">{flash ?? "Give prompt to your agent"}</span>
      </Button>
    </Tooltip>
  );
}

/** The prompt as a labelled alternative to doing the step by hand. */
export function AgentPromptRow({
  label,
  prompt,
  onCopied,
}: {
  label: string;
  prompt: string;
  onCopied?: () => void;
}) {
  return (
    <div className="per-agent-row">
      <span>{label}</span>
      <AgentPrompt prompt={prompt} onCopied={onCopied} variant="secondary" />
    </div>
  );
}
